const state = {
    code: '',
    titleInfo: { title: '', bg: 'default', isMore: false },
    userInfo: {},
    dingdingconfig: {},
    browser: {},
    historyPageName: ''
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js